import { createAction } from '../../../core/helpers'

import { FETCH_INGREDIENT_SPECIAL_CASE } from '../action-types'

const cleanupFetchIngredientSpecialCaseDetails = createAction(
  FETCH_INGREDIENT_SPECIAL_CASE.CLEANUP,
)

export default cleanupFetchIngredientSpecialCaseDetails
